var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', [_c('div', [_c('b-row', {
    staticClass: "mb-1 align-items-center"
  }, [_c('b-col', {
    staticClass: "mb-1 mb-sm-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "4"
    }
  }, [_c('b-form-input', {
    staticClass: "d-inline-block w-100",
    attrs: {
      "placeholder": "Search...",
      "type": "text"
    },
    on: {
      "keyup": _vm.onSearch
    },
    model: {
      value: _vm.searchTerm,
      callback: function callback($$v) {
        _vm.searchTerm = $$v;
      },
      expression: "searchTerm"
    }
  })], 1), _c('b-col', {
    staticClass: "d-flex justify-content-center justify-content-sm-end",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "8"
    }
  }, [_vm.$permissionAbility(_vm.HOURLY_PAYSLIP_POLICY_CREATE, _vm.permissions) ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v(" Create ")])] : _vm._e()], 2)], 1), _c('vue-good-table', {
    attrs: {
      "style-class": "vgt-table table-custom-style striped",
      "line-numbers": false,
      "mode": "remote",
      "total-rows": _vm.totalRecords,
      "is-loading": _vm.isLoading,
      "rows": _vm.rows,
      "sort-options": {
        enabled: false,
        multipleColumns: true,
        initialSortBy: [{
          field: 'id',
          type: 'desc'
        }, {
          field: 'created_at',
          type: 'desc'
        }]
      },
      "columns": _vm.columns,
      "pagination-options": {
        enabled: true,
        perPage: _vm.pageLength
      }
    },
    on: {
      "update:isLoading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "update:is-loading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$row, _props$row2;
        return [props.column.field === 'format_title' ? [_vm.$permissionAbility(_vm.HOURLY_PAYSLIP_POLICY_SHOW, _vm.permissions) ? _c('b', {
          staticClass: "cursor-pointer",
          on: {
            "click": function click($event) {
              return _vm.onShowPage(props.row);
            }
          }
        }, [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row = props.row) === null || _props$row === void 0 ? void 0 : _props$row.title) + " ")]) : _c('b', [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row2 = props.row) === null || _props$row2 === void 0 ? void 0 : _props$row2.title) + " ")])] : _vm._e(), props.column.field === 'format_duration' ? [props.row.duration_in_days ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v(" " + _vm._s(props.row.duration_in_days) + " ")]) : [_vm._v(" N/A ")]] : _vm._e(), props.column.field === 'format_work_hour' ? [props.row.work_hours ? _c('b-badge', {
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v(" " + _vm._s(props.row.work_hours) + " ")]) : [_vm._v(" N/A ")]] : _vm._e(), props.column.field === 'format_start_time' ? [props.row.start_time ? _c('b', [_vm._v(" " + _vm._s(_vm.formatFnTableCheckIn(props.row.start_time)) + " ")]) : [_vm._v(" N/A ")]] : _vm._e(), props.column.field === 'format_end_time' ? [props.row.end_time ? _c('b', [_vm._v(" " + _vm._s(_vm.formatFnTableCheckIn(props.row.end_time)) + " ")]) : [_vm._v(" N/A ")]] : _vm._e(), props.column.field === 'format_timer' ? [props.row.timer ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v(" On ")]) : _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v(" Off ")])] : _vm._e(), props.column.field === 'action' ? _c('span', [_c('span', [_c('b-dropdown', {
          attrs: {
            "variant": "link",
            "toggle-class": "text-decoration-none",
            "no-caret": ""
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function fn() {
              return [_c('feather-icon', {
                staticClass: "text-body align-middle mr-25",
                attrs: {
                  "icon": "MoreVerticalIcon",
                  "size": "16"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [_vm.$permissionAbility(_vm.HOURLY_PAYSLIP_POLICY_EDIT, _vm.permissions) ? [_c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.onShow(props.row);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "Edit2Icon"
          }
        }), _c('span', [_vm._v("Edit")])], 1)] : _vm._e(), _vm.$permissionAbility(_vm.HOURLY_PAYSLIP_POLICY_SHOW, _vm.permissions) ? [_c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.onShowPage(props.row);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "EyeIcon"
          }
        }), _c('span', [_vm._v("Show")])], 1)] : _vm._e(), _vm.$permissionAbility(_vm.HOURLY_PAYSLIP_POLICY_DELETE, _vm.permissions) ? [_c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.onDelete(props.row.id);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "TrashIcon"
          }
        }), _c('span', [_vm._v("Delete")])], 1)] : _vm._e()], 2)], 1)]) : _c('span', [_vm._v(" " + _vm._s(props.formattedRow[props.column.field]) + " ")])];
      }
    }, {
      key: "pagination-bottom",
      fn: function fn(props) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between flex-wrap"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-0 mt-1"
        }, [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Showing 1 to ")]), _c('b-form-select', {
          staticClass: "mx-1",
          attrs: {
            "options": ['10', '25', '50', '100', '500']
          },
          on: {
            "input": function input(value) {
              return props.perPageChanged({
                currentPerPage: value
              });
            }
          },
          model: {
            value: _vm.pageLength,
            callback: function callback($$v) {
              _vm.pageLength = $$v;
            },
            expression: "pageLength"
          }
        }), _c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" of " + _vm._s(props.total) + " entries ")])], 1), _c('div', [_c('b-pagination', {
          staticClass: "mt-1 mb-0",
          attrs: {
            "value": 1,
            "total-rows": props.total,
            "per-page": _vm.pageLength,
            "first-number": "",
            "last-number": "",
            "align": "right",
            "prev-class": "prev-item",
            "next-class": "next-item"
          },
          on: {
            "input": function input(value) {
              return props.pageChanged({
                currentPage: value
              });
            }
          },
          scopedSlots: _vm._u([{
            key: "prev-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronLeftIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }, {
            key: "next-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronRightIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }], null, true)
        })], 1)])];
      }
    }])
  })], 1), _c('b-modal', {
    attrs: {
      "id": "modal-hourly-policy-form",
      "centered": "",
      "title": _vm.modelType == 'editModel' ? 'Edit Hourly Work Policy' : 'Create Hourly Work Policy',
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.hiddenModal
    }
  }, [_c('validation-observer', {
    ref: "policyForm"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.submit($event);
      }
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Title",
      "label-for": "title"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "title",
      "vid": "title",
      "rules": "required|max:255"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "title",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Policy Title"
          },
          model: {
            value: _vm.title,
            callback: function callback($$v) {
              _vm.title = $$v;
            },
            expression: "title"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Duration (in days)",
      "label-for": "duration"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "duration",
      "vid": "duration",
      "rules": "required|min_value:1"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var errors = _ref2.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "duration",
            "type": "number",
            "state": errors.length > 0 ? false : null,
            "placeholder": "1"
          },
          model: {
            value: _vm.duration,
            callback: function callback($$v) {
              _vm.duration = $$v;
            },
            expression: "duration"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Work Hour",
      "label-for": "work_hour"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "work_hour",
      "vid": "work_hour",
      "rules": "required|min_value:1"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var errors = _ref3.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "work_hour",
            "type": "number",
            "state": errors.length > 0 ? false : null,
            "placeholder": "1"
          },
          model: {
            value: _vm.work_hour,
            callback: function callback($$v) {
              _vm.work_hour = $$v;
            },
            expression: "work_hour"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-checkbox', {
    staticClass: "custom-toggle",
    attrs: {
      "id": "customSwitchOverTime",
      "switch": ""
    },
    model: {
      value: _vm.timer,
      callback: function callback($$v) {
        _vm.timer = $$v;
      },
      expression: "timer"
    }
  }, [_vm._v(" Timer ")]), _vm.timer ? [_c('b-form-group', {
    attrs: {
      "label": "Check In*",
      "label-for": "check-in"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "check in",
      "vid": "check_in",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var errors = _ref4.errors;
        return [_c('flat-pickr', {
          staticClass: "form-control",
          attrs: {
            "id": "check-in",
            "placeholder": "09:00 AM",
            "config": {
              enableTime: true,
              noCalendar: true,
              static: true,
              dateFormat: 'H:i:S',
              altInput: true,
              altFormat: 'h:i K',
              minuteIncrement: 1
            },
            "state": errors.length > 0 ? false : null
          },
          model: {
            value: _vm.start_time,
            callback: function callback($$v) {
              _vm.start_time = $$v;
            },
            expression: "start_time"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 2920305515)
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Check Out*",
      "label-for": "check-out"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "check out",
      "vid": "check_out",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var errors = _ref5.errors;
        return [_c('flat-pickr', {
          staticClass: "form-control",
          attrs: {
            "id": "check-out",
            "placeholder": "06:00 PM",
            "config": {
              enableTime: true,
              noCalendar: true,
              static: true,
              dateFormat: 'H:i:S',
              altInput: true,
              altFormat: 'h:i K',
              minuteIncrement: 1
            },
            "state": errors.length > 0 ? false : null
          },
          model: {
            value: _vm.end_time,
            callback: function callback($$v) {
              _vm.end_time = $$v;
            },
            expression: "end_time"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 3888566707)
  })], 1)] : _vm._e(), _vm.isLoading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])]], 2)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }